import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class LockService {
    private locksApplied: number = 0;
    private isLockedInternal$ = new Subject<boolean>();
    public isLocked$ = this.isLockedInternal$.asObservable();

    public lock(): void {
        this.locksApplied++;
        this.isLockedInternal$.next(this.locksApplied > 0);
    }

    public unlock(): void {
        this.locksApplied--;
        this.isLockedInternal$.next(this.locksApplied > 0);
    }
}
